import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { NoiseOverlay } from "./NoiseOverlay";
import { API } from "../lib/api";
import { useReducedMotion } from "../lib/useReducedMotion";
import { useAuthStore } from "../state/authStore";

export const Layout = () => {
    const [company, setCompany] = useState(null);
    const location = useLocation();
    const reduced = useReducedMotion();
    const bootstrap = useAuthStore((s) => s.bootstrap);

    useEffect(() => {
        bootstrap();
    }, [bootstrap]);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await axios.get(`${API}/company`, { timeout: 8000 });
                if (!cancelled) setCompany(r.data);
            } catch (e) {
                console.error("Failed to load /api/company", e);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    // Scroll to top on route change
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
    }, [location.pathname, reduced]);

    const pageVariants = reduced
        ? {
              initial: { opacity: 1 },
              animate: { opacity: 1 },
              exit: { opacity: 1 },
          }
        : {
              initial: { opacity: 0, filter: "blur(4px)", y: 6 },
              animate: { opacity: 1, filter: "blur(0px)", y: 0 },
              exit: { opacity: 0, filter: "blur(4px)", y: -6 },
          };

    return (
        <div
            className="relative min-h-screen w-full overflow-x-hidden bg-canvas text-text-primary"
            data-testid="layout-root"
        >
            <NoiseOverlay />
            <Nav />
            <AnimatePresence mode="wait" initial={false}>
                <motion.main
                    key={location.pathname}
                    variants={pageVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                    className="relative z-[2]"
                    data-testid={`page-${location.pathname === "/" ? "home" : location.pathname.slice(1)}`}
                >
                    <Outlet context={{ company }} />
                </motion.main>
            </AnimatePresence>
            <Footer company={company} />
        </div>
    );
};

export default Layout;
